import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { RoleGuard } from './core/auth/role.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'agentlogin', pathMatch: 'full' },

  // Auth Layout (Unauthenticated Entry Points)
  {
    path: '',
    loadComponent: () =>
      import('./theme/authlayout/authlayout.component').then(
        (m) => m.AuthlayoutComponent
      ),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./modules/auth/adminlogin/adminlogin.component').then(
            (m) => m.AdminloginComponent
          )
      },
      {
        path: 'agentlogin',
        loadComponent: () =>
          import('./modules/auth/login/login.component').then(
            (m) => m.LoginComponent
          )
      }
    ]
  },

  // Admin Auth Layout (Password Reset / Changes)
  {
    path: '',
    loadComponent: () =>
      import('./modules/admin/admin-auth-layout/admin-auth-layout.component').then(
        (m) => m.AdminAuthLayoutComponent
      ),
    children: [
      {
        path: 'changepassword',
        loadComponent: () =>
          import('./modules/admin/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent
          )
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./modules/admin/forget-password/forget-password.component').then(
            (m) => m.ForgetpasswordComponent
          )
      },
      {
        path: 'resetpassword',
        loadComponent: () =>
          import('./modules/admin/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          )
      },
      {
        path: 'agentchangepassword',
        loadComponent: () =>
          import('./modules/admin/agentchangepassword/agentchangepassword.component').then(
            (m) => m.AgentchangepasswordComponent
          )
      }
    ]
  },

  // CRM / Admin Portal (Secured with AuthGuard & RoleGuard)
  {
    path: 'crm',
    loadComponent: () =>
      import('./theme/adminmasterlayout/adminmasterlayout.component').then(
        (m) => m.AdminmasterlayoutComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { expectedRole: 'crm' },
    children: [
      {
        path: 'admindashboard',
        loadComponent: () =>
          import('./modules/admin/admindashboard/admindashboard.component').then(
            (m) => m.AdmindashboardComponent
          )
      },
      {
        path: 'slider',
        loadComponent: () =>
          import('./modules/admin/login-slider/login-slider.component').then(
            (m) => m.LoginSliderComponent
          )
      },
      {
        path: 'popup',
        loadComponent: () =>
          import('./modules/admin/login-popup/login-popup.component').then(
            (m) => m.LoginPopupComponent
          )
      },
      {
        path: 'userlist',
        loadComponent: () =>
          import('./modules/admin/UserManagement/user-list/user-list.component').then(
            (m) => m.UserListComponent
          )
      },
      {
        path: 'rolelist',
        loadComponent: () =>
          import('./modules/admin/UserManagement/role-registration/role-registration.component').then(
            (m) => m.RoleRegistrationComponent
          )
      },
      {
        path: 'rolepermission',
        loadComponent: () =>
          import('./modules/admin/UserManagement/rolepermission/rolepermission.component').then(
            (m) => m.RolepermissionComponent
          )
      },
      {
        path: 'countrylist',
        loadComponent: () =>
          import('./modules/admin/countrylist/countrylist.component').then(
            (m) => m.CountrylistComponent
          )
      },
      {
        path: 'audit',
        loadComponent: () =>
          import('./modules/admin/audit-trail/audit-trail.component').then(
            (m) => m.AuditTrailComponent
          )
      },
      {
        path: 'crmresetpassword',
        loadComponent: () =>
          import('./modules/admin/admin-reset-password/admin-reset-password.component').then(
            (m) => m.AdminResetPasswordComponent
          )
      },
      {
        path: 'branchtype',
        loadComponent: () =>
          import('./modules/admin/outlettype/outlettype.component').then(
            (m) => m.OutlettypeComponent
          )
      },
      {
        path: 'branch',
        loadComponent: () =>
          import('./modules/admin/outletlist/outletlist.component').then(
            (m) => m.OutletlistComponent
          )
      },
      {
        path: 'addbranch',
        loadComponent: () =>
          import('./modules/admin/outlet/outlet.component').then(
            (m) => m.OutletComponent
          )
      },
      {
        path: 'addbranch/:id',
        loadComponent: () =>
          import('./modules/admin/outlet/outlet.component').then(
            (m) => m.OutletComponent
          )
      },
      {
        path: 'emailList',
        loadComponent: () =>
          import('./modules/admin/emailconfigurationlist/emailconfigurationlist.component').then(
            (m) => m.EmailconfigurationlistComponent
          )
      },
    {
      path: 'erp-config',
        loadComponent: () =>
          import('./modules/admin/erp-integration/erp-integration.component').then(
            (m) => m.ERPIntegrationComponent
          )
      },
          {
      path: 'erp-configuration',
        loadComponent: () =>
          import('./modules/admin/crm/erp-controls.component').then(
            (m) => m.ErpControlsComponent
          )
      },
      {
        path: 'productlist',
        loadComponent: () =>
          import('./modules/admin/product-list/product-list.component').then(
            (m) => m.ProductListComponent
          )
      },
      {
        path: 'commonmaster',
        loadComponent: () =>
          import('./modules/admin/commonmasters/commonmasters.component').then(
            (m) => m.CommonmastersComponent
          )
      },
      {
        path: 'profession',
        loadComponent: () =>
          import('./modules/admin/professionlist/professionlist.component').then(
            (m) => m.ProfessionlistComponent
          )
      },
      {
        path: 'agentdetailes',
        loadComponent: () =>
          import('./modules/admin/agentlist/agentlist.component').then(
            (m) => m.AgentlistComponent
          )
      },
      {
        path: 'addagent',
        loadComponent: () =>
          import('./modules/admin/agentdetailes/agentdetailes.component').then(
            (m) => m.AgentdetailesComponent
          )
      },
      {
        path: 'addNovibet',
        loadComponent: () =>
          import('./modules/admin/add-novibet/add-novibet.component').then(
            (m) => m.AddNovibetComponent
          )
      },
      {
        path: 'Agent',
        loadComponent: () =>
          import('./modules/admin/agent-legel-entity/agent-legel-entity.component').then(
            (m) => m.AgentLegelEntityComponent
          )
      },
      {
        path: 'AddagnetLegalEntitiy',
        loadComponent: () =>
          import('./modules/admin/addagent-legel-entity/addagent-legel-entity.component').then(
            (m) => m.AddagentLegelEntityComponent
          )
      },
      {
        path: 'IP-Restriction',
        loadComponent: () =>
          import('./modules/admin/IP-Restriction/IP-Restriction.component').then(
            (m) => m.IPRestrictionComponent
          )
      },
      {
        path: 'IP-Restriction/:id',
        loadComponent: () =>
          import('./modules/admin/IP-Restriction/IP-Restriction.component').then(
            (m) => m.IPRestrictionComponent
          )
      },
      {
        path: 'add-IP',
        loadComponent: () =>
          import('./modules/admin/add-ip-ristriction/add-ip-ristriction.component').then(
            (m) => m.AddIpRistrictionComponent
          )
      },
      {
        path: 'add-IP/:id',
        loadComponent: () =>
          import('./modules/admin/add-ip-ristriction/add-ip-ristriction.component').then(
            (m) => m.AddIpRistrictionComponent
          )
      },
      {
        path: 'cxvUpload',
        loadComponent: () =>
          import('./modules/admin/cxv-upload/cxv-upload.component').then(
            (m) => m.CxvUploadComponent
          )
      },
      {
        path: 'addcountry',
        loadComponent: () =>
          import('./modules/admin/addcountry/addcountry.component').then(
            (m) => m.AddcountryComponent
          )
      },
      {
        path: 'adduser',
        loadComponent: () =>
          import('./modules/admin/UserManagement/add-user/add-user.component').then(
            (m) => m.AddUserComponent
          )
      },
      {
        path: 'add-slider',
        loadComponent: () =>
          import('./modules/admin/upload-slider/upload-slider.component').then(
            (m) => m.UploadSliderComponent
          )
      },
      {
        path: 'popup/add-popup',
        loadComponent: () =>
          import('./modules/admin/addlogin-po-up/addlogin-po-up.component').then(
            (m) => m.AddloginPoUpComponent
          )
      },
      {
        path: 'add-emailconfig',
        loadComponent: () =>
          import('./modules/admin/addemailconfig/addemailconfig.component').then(
            (m) => m.AddemailconfigComponent
          )
      },
      {
        path: 'add-role',
        loadComponent: () =>
          import('./modules/admin/UserManagement/add-role/add-role.component').then(
            (m) => m.AddRoleComponent
          )
      },
      {
        path: 'add-document',
        loadComponent: () =>
          import('./modules/admin/add-document/add-document.component').then(
            (m) => m.AddDocumentComponent
          )
      },
      {
        path: 'addbranchtype',
        loadComponent: () =>
          import('./modules/admin/addoutlettype/addoutlettype.component').then(
            (m) => m.AddoutlettypeComponent
          )
      },
      {
        path: 'addprofession',
        loadComponent: () =>
          import('./modules/admin/addprofession/addprofession.component').then(
            (m) => m.AddprofessionComponent
          )
      },
      {
        path: 'addcommonmasters',
        loadComponent: () =>
          import('./modules/admin/add-commonmasters/add-commonmasters.component').then(
            (m) => m.AddCommonmastersComponent
          )
      },
      {
        path: 'commisionlist',
        loadComponent: () =>
          import('./modules/admin/commisionType-list/commisionType-list.component').then(
            (m) => m.CommisionTypeListComponent
          )
      },
      {
        path: 'add-commision-type',
        loadComponent: () =>
          import('./modules/admin/add-commision-type/add-commision-type.component').then(
            (m) => m.AddCommisionTypeComponent
          )
      },
      {
        path: 'country-principle',
        loadComponent: () =>
          import('./modules/admin/country-principle/country-principle.component').then(
            (m) => m.CountryPrincipleComponent
          )
      },
      {
        path: 'commissionmaster',
        loadComponent: () =>
          import('./modules/admin/commission-master/commission-master.component').then(
            (m) => m.CommissionMasterComponent
          )
      },
      {
        path: 'add-commissionmaster',
        loadComponent: () =>
          import('./modules/admin/add-commission-master/add-commission-master.component').then(
            (m) => m.AddCommissionMasterComponent
          )
      },
      {
        path: 'xml-file',
        loadComponent: () =>
          import('./modules/admin/xml-file/xml-file.component').then(
            (m) => m.XMLFileComponent
          )
      },
      {
        path: 'xml-list',
        loadComponent: () =>
          import('./modules/admin/xml-list/xml-list.component').then(
            (m) => m.XmlListComponent
          )
      },
      {
        path: 'xml-details',
        loadComponent: () =>
          import('./modules/admin/xml-info/xml-info.component').then(
            (m) => m.XmlInfoComponent
          )
      },
      {
        path: 'transaction-summary',
        loadComponent: () =>
          import('./modules/admin/transaction-summary/transaction-summary.component').then(
            (m) => m.TransactionSummaryComponent
          )
      },
      {
        path: 'agentpyments',
        loadComponent: () =>
          import('./modules/admin/agent-payment/agent-payment.component').then(
            (m) => m.AgentPaymentComponent
          )
      },
      {
        path: 'addpayment',
        loadComponent: () =>
          import('./modules/admin/add-payment/add-payment.component').then(
            (m) => m.AddPaymentComponent
          )
      },
      {
        path: 'bank-response',
        loadComponent: () =>
          import('./modules/admin/bank-response/bank-response.component').then(
            (m) => m.BankResponseComponent
          )
      },
      {
        path: 'bank-list',
        loadComponent: () =>
          import('./modules/admin/bank-list/bank-list.component').then(
            (m) => m.BankListComponent
          )
      },
      {
        path: 'add-banklist',
        loadComponent: () =>
          import('./modules/admin/add-banklist/add-banklist.component').then(
            (m) => m.AddBanklistComponent
          )
      },
      {
        path: 'searchTransaction',
        loadComponent: () =>
          import('./modules/admin/search-transaction/search-transaction.component').then(
            (m) => m.SearchTransactionComponent
          )
      },
      {
        path: 'customer',
        loadComponent: () =>
          import('./modules/admin/search-customer/search-customer.component').then(
            (m) => m.SearchCustomerComponent
          )
      },
      {
        path: 'addcustomer',
        loadComponent: () =>
          import('./modules/admin/add-customer/add-customer.component').then(
            (m) => m.AddCustomerComponent
          )
      },
      {
        path: 'addcustomer/:id',
        loadComponent: () =>
          import('./modules/admin/add-customer/add-customer.component').then(
            (m) => m.AddCustomerComponent
          )
      },
      {
        path: 'uplodList',
        loadComponent: () =>
          import('./modules/admin/seebi-list/seebi-list.component').then(
            (m) => m.SeebiListComponent
          )
      },
      {
        path: 'agentCreditManagement',
        loadComponent: () =>
          import('./modules/admin/credit-management/credit-management.component').then(
            (m) => m.CreditManagementComponent
          )
      },
      {
        path: 'addnewPayment',
        loadComponent: () =>
          import('./modules/admin/addnew-payment/addnew-payment.component').then(
            (m) => m.AddnewPaymentComponent
          )
      },
      {
        path: 'TransactionCenter',
        loadComponent: () =>
          import('./modules/admin/transaction-report/transaction-center/transaction-center.component').then(
            (m) => m.TransactionCenterComponent
          )
      },
      {
        path: 'transaction-center-details/:id',
        loadComponent: () =>
          import('./modules/admin/transaction-report/transaction-center-details/transaction-center-details.component').then(
            (m) => m.TransactionCenterDetailsComponent
          )
      },
      {
        path: 'AmlCenter',
        loadComponent: () =>
          import('./modules/admin/aml-alert-detailes/aml-alert-detailes.component').then(
            (m) => m.AmlAlertDetailesComponent
          )
      },
      {
        path: 'internalblacklist',
        loadComponent: () =>
          import('./modules/admin/internalblacklist/internalblacklist.component').then(
            (m) => m.InternalblacklistComponent
          )
      },
      {
        path: 'amlDetailes',
        loadComponent: () =>
          import('./modules/admin/aml-full-detailes/aml-full-detailes.component').then(
            (m) => m.AmlFullDetailesComponent
          )
      },
      {
        path: 'risklevel',
        loadComponent: () =>
          import('./modules/admin/risk-level/risk-level.component').then(
            (m) => m.RiskLevelComponent
          )
      },
      {
        path: 'SanctionCenter',
        loadComponent: () =>
          import('./modules/admin/sanction-search/sanction-search.component').then(
            (m) => m.SanctionSearchComponent
          )
      },
      {
        path: 'amlDetailes/:id',
        loadComponent: () =>
          import('./modules/admin/aml-full-detailes/aml-full-detailes.component').then(
            (m) => m.AmlFullDetailesComponent
          )
      },
      {
        path: 'novibet-user',
        loadComponent: () =>
          import('./modules/admin/novibet-user/novibet-user.component').then(
            (m) => m.NovibetUserComponent
          )
      },
      {
        path: 'agentinfo',
        loadComponent: () =>
          import('./modules/admin/agentinfo/agentinfo.component').then(
            (m) => m.AgentinfoComponent
          )
      },
      {
        path: 'AmlCenter/:id',
        loadComponent: () =>
          import('./modules/admin/aml-alert-detailes/aml-alert-detailes.component').then(
            (m) => m.AmlAlertDetailesComponent
          )
      },
      {
        path: 'printPdf',
        loadComponent: () =>
          import('./modules/transaction/sendtobank/pdfreader/pdfreader.component').then(
            (m) => m.PdfreaderComponent
          )
      },
      {
        path: 'billPaymentCategories',
        loadComponent: () =>
          import('./modules/admin/bill-payment/bill-payment-categories/bill-payment-categories.component').then(
            (m) => m.BillPaymentCategoriesComponent
          )
      },
      {
        path: 'billOrganisation',
        loadComponent: () =>
          import('./modules/admin/bill-payment/bill-payment-organisation/bill-payment-organisation.component').then(
            (m) => m.BillPaymentOrganisationComponent
          )
      },
      {
        path: 'addbillcategory',
        loadComponent: () =>
          import('./modules/admin/bill-payment/add-bill-payment-categories/add-bill-payment-categories.component').then(
            (m) => m.AddBillPaymentCategoriesComponent
          )
      },
      {
        path: 'addbillcategory/:id',
        loadComponent: () =>
          import('./modules/admin/bill-payment/add-bill-payment-categories/add-bill-payment-categories.component').then(
            (m) => m.AddBillPaymentCategoriesComponent
          )
      },
      {
        path: 'addbillorganziation',
        loadComponent: () =>
          import('./modules/admin/bill-payment/add-bill-payment-organisation/add-bill-payment-organisation.component').then(
            (m) => m.AddBillPaymentOrganisationComponent
          )
      },
      {
        path: 'addbillorganziation/:id',
        loadComponent: () =>
          import('./modules/admin/bill-payment/add-bill-payment-organisation/add-bill-payment-organisation.component').then(
            (m) => m.AddBillPaymentOrganisationComponent
          )
      },
      {
        path: 'inp-file-generation',
        loadComponent: () =>
          import('./modules/admin/bill_Payment/inp-generation/inp-generation.component').then(
            (m) => m.InpGenerationComponent
          )
      },
      {
        path: 'chk-response',
        loadComponent: () =>
          import('./modules/admin/bill_Payment/chk-response/chk-response.component').then(
            (m) => m.ChkResponseComponent
          )
      },
      {
        path: 'ans-response',
        loadComponent: () =>
          import('./modules/admin/bill_Payment/ans-response/ans-response.component').then(
            (m) => m.AnsResponseComponent
          )
      },
      {
        path: 'feefxmanagement',
        loadComponent: () =>
          import('./modules/admin/fee-fx-management/fee-fx-management.component').then(
            (m) => m.FeeFxManagementComponent
          )
      },
      {
        path: 'addfeefxmanagement',
        loadComponent: () =>
          import('./modules/admin/add-fee-fx-management/add-fee-fx-management.component').then(
            (m) => m.AddFeeFxManagementComponent
          )
      },
      {
        path: 'addfeefxmanagement/:id',
        loadComponent: () =>
          import('./modules/admin/add-fee-fx-management/add-fee-fx-management.component').then(
            (m) => m.AddFeeFxManagementComponent
          )
      },
      {
        path: 'Sanction',
        loadComponent: () =>
          import('./modules/admin/sanction-list/sanction-list.component').then(
            (m) => m.SanctionListComponent
          )
      },
      {
        path: 'Sanction/:id',
        loadComponent: () =>
          import('./modules/admin/sanction-list/sanction-list.component').then(
            (m) => m.SanctionListComponent
          )
      },
      {
        path: 'mg-commision-report',
        loadComponent: () =>
          import('./modules/admin/mg-commission-report/mg-commission-report.component').then(
            (m) => m.MgCommissionReportComponent
          )
      },
      {
        path: 'manualsList',
        loadComponent: () =>
          import('./modules/admin/manuals/manuals.component').then(
            (m) => m.ManualsComponent
          )
      },
      {
        path: 'addManualsList',
        loadComponent: () =>
          import('./modules/admin/add-manuals/add-manuals.component').then(
            (m) => m.AddManualsComponent
          )
      },
      {
        path: 'manual',
        loadComponent: () =>
          import('./modules/admin/manual-viewer/manual-viewer.component').then(
            (m) => m.ManualViewerComponent
          )
      },
      {
        path: 'principal-cost',
        loadComponent: () =>
          import('./modules/admin/principal-cost/principal-cost.component').then(
            (m) => m.PrincipalCostComponent
          )
      },
      {
        path: 'thirdParty-Cost',
        loadComponent: () =>
          import('./modules/admin/third-party-cost/third-party-cost.component').then(
            (m) => m.ThirdPartyCostComponent
          )
      },
      {
        path: 'tpc-Edit',
        loadComponent: () =>
          import('./modules/admin/third-party-cost/third-party-cost-edit/third-party-cost-edit.component').then(
            (m) => m.ThirdPartyCostEditComponent
          )
      },
      {
        path: 'principal-cost/:id',
        loadComponent: () =>
          import('./modules/admin/principal-cost/principal-cost.component').then(
            (m) => m.PrincipalCostComponent
          )
      },
      {
        path: 'add-principal',
        loadComponent: () =>
          import('./modules/admin/add-principal-cost/add-principal-cost.component').then(
            (m) => m.AddPrincipalCostComponent
          )
      },
      {
        path: 'calculator',
        loadComponent: () =>
          import('./modules/Tools/calculator-tool/calculator-tool.component').then(
            (m) => m.CalculatorToolComponent
          )
      },
      {
        path: 'agent-commissions',
        loadComponent: () =>
          import('./modules/admin/agents-commissions/agents-commissions.component').then(
            (m) => m.AgentCommissionsComponent
          )
      },
      {
        path: 'directpay-commissions',
        loadComponent: () =>
          import('./modules/admin/directpay-commissions/directpay-commissions.component').then(
            (m) => m.DirectpayCommissionsComponent
          )
      },
      {
        path: 'extra-commissions',
        loadComponent: () =>
          import('./modules/admin/extra-commissions/extra-commissions.component').then(
            (m) => m.ExtraCommissionsComponent
          )
      },
      {
        path: 'manage-commissions',
        loadComponent: () =>
          import('./modules/admin/manage-commissions/manage-commissions.component').then(
            (m) => m.ManageCommissionsComponent
          )
      },
      {
        path: 'add-manage-commissions',
        loadComponent: () =>
          import('./modules/admin/add-manage-commission/add-manage-commission.component').then(
            (m) => m.AddManageCommissionComponent
          )
      },
      {
        path: 'add-manage-commissions/:id',
        loadComponent: () =>
          import('./modules/admin/add-manage-commission/add-manage-commission.component').then(
            (m) => m.AddManageCommissionComponent
          )
      },
      {
        path: 'refund-completed',
        loadComponent: () =>
          import('./modules/transaction/sendmoney/refund-transaction-complition/refund-transaction-complition.component').then(
            (m) => m.RefundTransactionComplitionComponent
          )
      },
      {
        path: 'commisionTypes',
        loadComponent: () =>
          import('./modules/admin/commission-type-master/commission-type-master.component').then(
            (m) => m.CommissionTypeMasterComponent
          )
      },
      {
        path: 'add-commisionTypes',
        loadComponent: () =>
          import('./modules/admin/add-commission-type-master/add-commission-type-master.component').then(
            (m) => m.AddCommissionTypeMasterComponent
          )
      },
      {
        path: 'agent-diary',
        loadComponent: () =>
          import('./modules/admin/agent-diary/agent-diary.component').then(
            (m) => m.AgentDiaryComponent
          )
      },
      {
        path: 'transaction-summery-report',
        loadComponent: () =>
          import('./modules/admin/transaction-summary-report/transaction-summary-report.component').then(
            (m) => m.TransactionSummaryReportComponent
          )
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./modules/admin/payments/payments.component').then(
            (m) => m.PaymentsComponent
          )
      },
      {
        path: 'crm-reports',
        loadComponent: () =>
          import('./modules/admin/crm/crm.component').then(
            (m) => m.CrmComponent
          )
      },
      {
        path: 'fee-configuration',
        loadComponent: () =>
          import('./modules/admin/fee-configuration/fee-configuration.component').then(
            (m) => m.FeeConfigrationComponent
          )
      },
      {
        path: 'add-fee-configuration',
        loadComponent: () =>
          import('./modules/admin/add-fee-configuration/add-fee-configuration.component').then(
            (m) => m.AddFeeConfigrationComponent
          )
      },
      {
        path: 'add-fee-configuration/:id',
        loadComponent: () =>
          import('./modules/admin/add-fee-configuration/add-fee-configuration.component').then(
            (m) => m.AddFeeConfigrationComponent
          )
      }
    ]
  },

  // Standalone Novibet & Report Routes (Protected with AuthGuard)
  {
    path: 'novibet/transaction-details/:transactionId',
    loadComponent: () =>
      import('./modules/transaction/novibet/novibet-location/novibet-location.component').then(
        (m) => m.NovibetLocationComponent
      ),
   
  },
  {
    path: 'novibet/transaction-withdrawal-details/:transactionId',
    loadComponent: () =>
      import('./modules/transaction/novibet/novibet-witdrawal-popup/novibet-witdrawal-popup.component').then(
        (m) => m.NovibetWitdrawalPopupComponent
      ),
    
  },
  {
    path: 'service-location-reports',
    loadComponent: () =>
      import('./modules/Reports/service-location-report/service-location-report.component').then(
        (m) => m.ServiceLocationReportComponent
      ),
    
  },


  // Agent Portal Section (Secured with AuthGuard & RoleGuard)
  {
    path: 'agent',
    loadComponent: () =>
      import('./theme/adminlayout/adminlayout.component').then(
        (m) => m.AdminlayoutComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { expectedRole: 'agent' },
    children: [
      {
        path: 'customerDetails',
        loadComponent: () =>
          import('./modules/admin/add-customer/add-customer.component').then(
            (m) => m.AddCustomerComponent
          )
      },
      {
        path: 'customerDetails/:id',
        loadComponent: () =>
          import('./modules/admin/add-customer/add-customer.component').then(
            (m) => m.AddCustomerComponent
          )
      },
      {
        path: 'manual',
        loadComponent: () =>
          import('./modules/admin/manuals/manuals.component').then(
            (m) => m.ManualsComponent
          )
      },
      {
        path: 'manuals',
        loadComponent: () =>
          import('./modules/admin/manual-viewer/manual-viewer.component').then(
            (m) => m.ManualViewerComponent
          )
      },
      {
        path: 'services',
        loadComponent: () =>
          import('./modules/agent/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          )
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/services/listservices/listservices.component').then(
            (m) => m.ListservicesComponent
          )
      },
      {
        path: 'locationlist',
        loadComponent: () =>
          import('./modules/auth/location-list/location-list.component').then(
            (m) => m.LocationListComponent
          )
      },
      {
        path: 'addcustomer',
        loadComponent: () =>
          import('./modules/transaction/sendmoney/customerdetails/customerdetails.component').then(
            (m) => m.CustomerdetailsComponent
          )
      },
      {
        path: 'searchTransaction',
        loadComponent: () =>
          import('./modules/admin/search-transaction/search-transaction.component').then(
            (m) => m.SearchTransactionComponent
          )
      },
      {
        path: 'calculator',
        loadComponent: () =>
          import('./modules/Tools/calculator-tool/calculator-tool.component').then(
            (m) => m.CalculatorToolComponent
          )
      },
      {
        path: 'user-request',
        loadComponent: () =>
          import('./modules/Tools/user-request/user-request.component').then(
            (m) => m.UserRequestComponent
          )
      },
      {
        path: 'add-user',
        loadComponent: () =>
          import('./modules/Tools/add-delete-user/add-delete-user.component').then(
            (m) => m.AddDeleteUserComponent
          )
      },
      {
        path: 'memo',
        loadComponent: () =>
          import('./modules/Tools/memo/memo.component').then(
            (m) => m.MemoComponent
          )
      },
      {
        path: 'payment-info',
        loadComponent: () =>
          import('./modules/Tools/payment-info/payment-info.component').then(
            (m) => m.PaymentInfoComponent
          )
      },
      {
        path: 'user-requests',
        loadComponent: () =>
          import('./modules/Tools/agent-list/agent-list.component').then(
            (m) => m.AgentListComponent
          )
      },
      {
        path: 'commission-report',
        loadComponent: () =>
          import('./modules/Reports/commission-report/commission-report.component').then(
            (m) => m.CommissionReportComponent
          )
      },
      {
        path: 'agent-user-location-diary',
        loadComponent: () =>
          import('./modules/Reports/agent-user-location-diary/agent-user-location-diary.component').then(
            (m) => m.AgentUserLocationDiaryComponent
          )
      },
      {
        path: 'transaction-history-report',
        loadComponent: () =>
          import('./modules/Reports/transaction-history-report/transaction-history-report.component').then(
            (m) => m.TransactionHistoryReportComponent
          )
      },
      {
        path: 'location-report',
        loadComponent: () =>
          import('./modules/Reports/location-report/location-report.component').then(
            (m) => m.LocationReportComponent
          )
      },
      {
        path: 'service-location-report',
        loadComponent: () =>
          import('./modules/Reports/service-location-report/service-location-report.component').then(
            (m) => m.ServiceLocationReportComponent
          )
      },
      {
        path: 'payment-report',
        loadComponent: () =>
          import('./modules/Reports/payment-report/payment-report.component').then(
            (m) => m.PaymentReportComponent
          )
      },
      {
        path: 'transaction-center',
        loadComponent: () =>
          import('./modules/admin/transaction-report/transaction-center/transaction-center.component').then(
            (m) => m.TransactionCenterComponent
          )
      },
      {
        path: 'refund-completed',
        loadComponent: () =>
          import('./modules/transaction/sendmoney/refund-transaction-complition/refund-transaction-complition.component').then(
            (m) => m.RefundTransactionComplitionComponent
          )
      },
      {
        path: 'novibet-transaction-complete',
        loadComponent: () =>
          import('./modules/transaction/novibet/novibet-transaction/novibet-transaction.component').then(
            (m) => m.NovibetTransactionComponent
          )
      },
      {
        path: 'transaction-center-details/:id',
        loadComponent: () =>
          import('./modules/admin/transaction-report/transaction-center-details/transaction-center-details.component').then(
            (m) => m.TransactionCenterDetailsComponent
          )
      },
      {
        path: 'pdfViewer',
        loadComponent: () =>
          import('./modules/transaction/sendtobank/pdfreader/pdfreader.component').then(
            (m) => m.PdfreaderComponent
          )
      },
      {
        path: 'notificationList',
        loadComponent: () =>
          import('./shared/components/notification-grid-list/notification-grid-list.component').then(
            (m) => m.NotificationGridListComponent
          )
      },
      {
        path: 'aircash',
        loadComponent: () =>
          import('./modules/transaction/aircash-main/aircash/aircash.component').then(
            (m) => m.AircashComponent
          )
      },
      {
        path: 'aircash-complete',
        loadComponent: () =>
          import('./modules/transaction/aircash-main/aircash-complete/aircash-complete.component').then(
            (m) => m.AircashCompleteComponent
          )
      },
      {
        path: 'novibet-send',
        loadComponent: () =>
          import('./modules/transaction/novibet/novibet-send/novibet-send.component').then(
            (m) => m.NovibetSendComponent
          )
      },
      {
        path: 'novibet-receive',
        loadComponent: () =>
          import('./modules/transaction/novibet/novibet-receive/novibet-receive.component').then(
            (m) => m.NovibetReceiveComponent
          )
      },
      {
        path: 'novibet',
        loadComponent: () =>
          import('./modules/transaction/novibet/novibet-landing/novibet-landing.component').then(
            (m) => m.NovibetLandingComponent
          )
      },

      // Feature Transaction Subroutes (Lazy feature route modules)
      {
        path: 'send-money',
        canMatch: [AuthGuard],
        loadChildren: () =>
          import('./modules/transaction/sendmoney/sendmoney.routes').then(
            (m) => m.routes
          )
      },
      {
        path: 'receive-money',
        canMatch: [AuthGuard],
        loadChildren: () =>
          import('./modules/transaction/receive-money/receivemoney').then(
            (m) => m.routes
          )
      },
      {
        path: 'send-to-bank',
        canMatch: [AuthGuard],
        loadChildren: () =>
          import('./modules/transaction/sendtobank/sendtobank.routes').then(
            (m) => m.routes
          )
      },
      {
        path: 'bill-pay',
        canMatch: [AuthGuard],
        loadChildren: () =>
          import('./modules/transaction/bill-payments/billpayment.routes').then(
            (m) => m.routes
          )
      },
      {
        path: 'incash',
        canMatch: [AuthGuard],
        loadChildren: () =>
          import('./modules/transaction/incash/incash.routes').then(
            (m) => m.routes
          )
      }
    ]
  },

  // Fallback Route Handling
  {
    path: '404',
    loadComponent: () =>
      import('./shared/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      )
  },
  {
    path: '**',
    redirectTo: '404'
  }
];
